import React from "react";

import "./Footer.scss"

const Footer = () => {
    return (
        <footer className="footer text-sm text-normal">
            <p>
                <a href="tel:8608181043">860-818-1043</a>
            </p>
            <p>
                <a href="mailto:joebegley15@gmail.com">joebegley15@gmail.com</a>
            </p>
            <p>
                © 2026 Big Blue Cooler, LLC
            </p>
        </footer>
    )
}

export default Footer;